/* unplugin-vue-components disabled */import script from "./Menu.vue?vue&type=script&setup=true&lang=js"
export * from "./Menu.vue?vue&type=script&setup=true&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=2551f554&lang=stylus"

const __exports__ = script;

export default __exports__